import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import FormGroup from "@material-ui/core/FormGroup";
import Divider from "@material-ui/core/Divider";
import Tooltip from "@material-ui/core/Tooltip";
import FormControl from "@material-ui/core/FormControl";
import NativeSelect from "@material-ui/core/NativeSelect";
import Input from "@material-ui/core/Input";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import { getErrorString } from "../display/ErrorStrings";
import PopupMessage from "../components/PopupMessage";
import PopupPrintMessage from "../components/PopupPrintMessage";

import BulkUploadIcon from "@material-ui/icons/CloudUploadOutlined";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
});

class BulkUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      notifyString: "",
      summaryString: "",
      minutesLeft: "-1",
      canDo: false,
      formats: [],
      format: "",
      uploadFile: null,
      waiting: false,
    };
    this.onClose = this.onClose.bind(this);
    this.onClosePopup = this.onClosePopup.bind(this);
  }

  onClosePopup(e) {
    this.setState({ errorString: "" });
    this.setState({ notifyString: "" });
    this.setState({ summaryString: "" });
  }

  componentDidMount() {
    fetch("on_upload_item", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        transit: this.props.accountObject.transit,
        account: this.props.accountObject.account,
        range_start: this.props.accountObject.rangeStart,
        range_end: this.props.accountObject.rangeEnd,
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else {
          if (reply.error) {
            this.setState({ errorString: reply.errorString });
          }
          this.setState({ minutesLeft: reply.minutesLeft });
          if (reply.minutesLeft !== "0" && reply.minutesLeft !== "-1")
            this.setState({ canDo: true });
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
      });
    fetch("on_bulk_upload_file_formats", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        transit: this.props.accountObject.transit,
        account: this.props.accountObject.account,
        type: this.props.accountObject.accountType,
        rangeStart: this.props.accountObject.rangeStart,
        rangeEnd: this.props.accountObject.rangeEnd,
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ errorString: reply.errorString });
        } else {
          if (reply.warning) {
            this.setState({ notifyString: reply.warningString });
          } else {
            this.setState({ formats: reply.formats });
            this.setState({ format: reply.formats[0] });
          }
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
      });
  }

  onClose(e) {
    e.preventDefault();
    this.props.onCloseUpload(e);
  }

  handleFormatChange(e) {
    e.preventDefault();
    this.setState({ format: e.target.value });
  }

  handleFile(e) {
    e.preventDefault();
    if (e.target.files !== null && e.target.files.length > 0) {
      this.setState({ uploadFile: e.target.files[0] });
    } else {
      this.setState({ uploadFile: null });
    }
  }

  handleUpload(e) {
    if (this.props.viewOnly) {
      this.setState({
        errorString: getErrorString(
          "viewOnly.warning",
          "Operation not allowed in support mode."
        ),
      });
      return;
    }
    this.setState({ waiting: true });
    //		this.setState({ uploadFile: null});
    let formData = new FormData();
    formData.append("transit", this.props.accountObject.transit);
    formData.append("account", this.props.accountObject.account);
    formData.append("type", this.props.accountObject.accountType);
    formData.append("rangeStart", this.props.accountObject.rangeStart);
    formData.append("rangeEnd", this.props.accountObject.rangeEnd);
    formData.append("file", this.state.uploadFile);
    formData.append("fileFormat", this.state.format);
    formData.append("secureToken", this.props.secureToken);

    fetch("on_bulk_upload_file", {
      method: "POST",
      credentials: "same-origin",
      body: formData,
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ uploadFile: null });
          this.setState({ errorString: reply.errorString });
          this.setState({ waiting: false });
        } else {
          this.setState({ waiting: false });
          if (reply.warning) {
            this.setState({ notifyString: reply.warningString });
          } else {
            var summary = "Your file has been uploaded.\n\nSummary:\n\n";
            for (let i = 0; i < reply.bulkUploadData.length; i++) {
              summary +=
                "ImportID:\t\t\t" + reply.bulkUploadData[i].importid + "\n";
              summary +=
                "Issue checks count (amount):\t" +
                reply.bulkUploadData[i].tot_numchk +
                " ($" +
                reply.bulkUploadData[i].tot_amnt +
                ")\n";
              summary +=
                "Void checks count (amount):\t" +
                reply.bulkUploadData[i].tot_numchk_void +
                " ($" +
                reply.bulkUploadData[i].tot_amnt_void +
                ")\n";
              summary +=
                "First / Last check number:\t" +
                reply.bulkUploadData[i].first_cheq_no +
                " / " +
                reply.bulkUploadData[i].last_cheq_no +
                "\n";
              summary +=
                "Status:\t\t\t" + reply.bulkUploadData[i].import_state + "\n\n";
            }
            this.setState({ summaryString: summary });
          }
        }
      })
      .catch((error) => {
        this.setState({ uploadFile: null });
        this.setState({ waiting: false });
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
      });
  }

  render() {
    let formats = this.state.formats;
    let { t } = this.props;
    return (
      <div>
        {this.state.errorString.length > 0 && (
          <PopupMessage
            title={getErrorString("general.error", "Error:")}
            text={this.state.errorString}
            error={true}
            onClosePopup={this.onClosePopup}
          />
        )}
        {this.state.notifyString.length > 0 && (
          <PopupMessage
            title={getErrorString("general.info.title", "Information")}
            text={this.state.notifyString}
            error={false}
            onClosePopup={this.onClose}
          />
        )}
        {this.state.summaryString.length > 0 && (
          <PopupPrintMessage
            title={getErrorString("general.info.title", "Information")}
            text={this.state.summaryString}
            error={false}
            onClosePopup={this.onClose}
          />
        )}
        {this.state.waiting && (
          <Typography variant="h6" color="primary">
            &nbsp;&nbsp;{t("waiting.label")}
          </Typography>
        )}
        {this.state.errorString.length === 0 && !this.state.waiting && (
          <div>
            <Paper elevation={5}>
              <Typography variant="body1" color="error">
                {this.state.minutesLeft === 0
                  ? t("uploadNoTime.label")
                  : this.state.minutesLeft === -1
                  ? t("uploadNotAvai.label")
                  : t("youHave.label") +
                    "     " +
                    this.state.minutesLeft +
                    t("uploadMinLeft.label")}
              </Typography>
              <FormGroup row>
                <Typography variant="h6" color="primary">
                  &nbsp;&nbsp; {t("bulkUpload.button")}
                  &nbsp;&nbsp;
                </Typography>
                <Tooltip title="Upload selected file">
                  <Button
                    disabled={
                      this.state.uploadFile === null || !this.state.canDo
                    }
                    onClick={(event) => this.handleUpload(event)}
                    color="primary"
                  >
                    <BulkUploadIcon />
                    &nbsp;{t("upload.label")}
                  </Button>
                </Tooltip>
              </FormGroup>
              <Divider />
            </Paper>
            <div style={{ margin: 20 }}>
              <Typography variant="caption">{t("fileFormat.label")}</Typography>
              &nbsp;&nbsp;
              <FormControl>
                <NativeSelect
                  style={{
                    height: 27,
                    verticalAlign: "textTop",
                    margin: 0,
                    width: 650,
                  }}
                  defaultValue={this.state.format}
                  input={<Input id="file_format" />}
                  onChange={(event) => this.handleFormatChange(event)}
                >
                  {formats.map((n) => {
                    return <option value={n}>{n}</option>;
                  })}
                </NativeSelect>
              </FormControl>
            </div>
            <div style={{ margin: 20 }}>
              <Typography variant="caption">{t("file.label")}</Typography>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <input
                type="file"
                size="200"
                onChange={(event) => this.handleFile(event)}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(BulkUpload));
